import React, { useState } from "react";
import { Box, MenuItem, TextField } from "@mui/material";
import "./FooterLanguage.css";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/hooks/store.hooks";
import { changeLanguageThunk } from "../../../store/models/profile/profile.thunk";

export const FooterLanguage = () => {
  const { i18n } = useTranslation();
  const initValue = i18n.resolvedLanguage || i18n.language;
  const dispatch = useAppDispatch();
  const [select, setSelect] = useState(initValue);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    dispatch(changeLanguageThunk());
  };

  return (
    <Box className="language-footer" sx={{ display: { xs: "block" } }}>
      <TextField
        className="slots-filter__select language-footer__container"
        select
        size="small"
        id="language-footer"
        name="language-footer"
        value={select}
        sx={{ width: "100%" }}
        SelectProps={{
          sx: {
            width: "100%",
          },
        }}
      >
        <MenuItem
          style={{ maxHeight: "300px", overflow: "auto" }}
          onClick={() => {
            setSelect("en");
            changeLanguage("en");
          }}
          value={"en"}
        >
          English
        </MenuItem>
        <MenuItem
          style={{ maxHeight: "300px", overflow: "auto" }}
          onClick={() => {
            setSelect("ru");
            changeLanguage("ru");
          }}
          value={"ru"}
        >
          Русский
        </MenuItem>

        <MenuItem
          style={{ maxHeight: "300px", overflow: "auto" }}
          onClick={() => {
            setSelect("tr");
            changeLanguage("tr");
          }}
          value={"tr"}
        >
          Turkish
        </MenuItem>
      </TextField>
    </Box>
  );
};
